import { type } from '../../utils/assist'

export default {
	data() {
		return {
			config: {},
			configBubble: true, // config更新是否冒泡
			configExclude: [], // 非配置项prop
			configWatchers: [], // 自定义watch
		}
	},

	methods: {
		resolve() {
			return ""
		},

		exportConfig(config) {
			return config
		},

		updateConfig(path, config) {
			if (type(path) == "string" && path.length > 0) {
				var parts = path.split("."),
					length = parts.length,
					target = this.config

				parts.forEach((p, depth) => {
					if (depth < length - 1) {
						if (type(target[p]) != "object" && type(target[p]) != "array") {
							if (isNaN(p)) {
								this.$set(target, p, {})
							} else {
								this.$set(target, p, [])
							}
						}

						target = target[p]
					}
				})

				if (target) {
					if (type(config) == "undefined") {
						this.$delete(target, parts[length - 1])
					} else {
						this.$set(target, parts[length - 1], config)
					}
				}
			}
		},

		// 迭代处理prop
		iterateProps(cb){
			Object.keys(this.$props).forEach(k => {
				// 排除非配置字段
				if (this.configExclude == "all") {
					return true
				}

				if (this.configExclude.indexOf(k) < 0) {
					var v = this.$props[k]

					if(cb){
						cb.call(this, v, k, this.$props)
					}
				}
			})
		},

		watchProps() {
			// prop更新次数
			var updateCount = 0

			return this.$watch(function() {
				this.iterateProps()

				return updateCount++
			}, function() {
				this.iterateProps((v, k) => {
					if(type(v) == "undefined"){
						this.$delete(this.config, k)
					}else{
						this.$set(this.config, k, v)
					}
				})
				
				this.config = this.exportConfig(this.config)
			}, {
				immediate: true
			})
		}
	},

	watch: {
		'config': {
			handler: function(config) {
				// 向上级联更新config
				if (this.configBubble && this.$parent && this.$parent.updateConfig) {
					this.$parent.updateConfig(this.resolve(), config)
				}
			},
			deep: true
		},
		'configExclude': {
			handler(val) {
				this.configWatchers.forEach(unwatch => unwatch())
				this.configWatchers.splice(0, this.configWatchers.length, this.watchProps())
			}
		}
	},

	created() {
		this.configWatchers.push(this.watchProps())
	},

	beforeDestroy() {
		// 移除config
		this.config = void(0)
		this.configWatchers = []
	}
}